<template>
  <intro-box>
    <div :class="content_class" v-html="description" />
    <div class="introduction-spacer"></div>
    <div class="bottom_align">
      <button type="button" class="button is-primary is-rounded right" @click="goToFirstStep">
        Jag förstår, nu kör vi!
      </button>
    </div>
  </intro-box>
</template>

<script>
import IntroBox from '@/components/elements/IntroBox.vue'

export default {
  computed: {
    task() {
      return this.$store.state.assignment.task
    },
    assignment() {
      return this.$store.state.assignment
    },
    chapter() {
      return this.$store.state.assignment.chapter
    },
    continue_chapter(){
      return this.$store.state.continue_chapter
    },
    show_chapter_intro(){
      return this.$store.state.show_chapter_intro
    },
    description() {
      return this.chapter.introduction
    },
    content_class(){
      if(this.task.scene_number){
        return "video-introduction-content text-content"
      }else{
        return "introduction-content text-content"
      }
    }
  },
  components: {
    IntroBox
  },
  methods: {
    goToFirstStep() {
      if(this.task.scene_number){
        // when task has scene_number, load video
        this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}/herocard`})
      } else {
        this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}/introduction`})
      }

    }
  },
  mounted: function() {
    if (this.assignment && this.assignment.status == "completed") {
      this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}/confirmation`})
    }else{
      if (!this.chapter.task_chapter){
        this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}/introduction`})
      }
    }
  }
}
</script>
<style>
  .button {
    margin-top: auto;
    bottom: 0;
  }

  .button.is-rounded {
    padding: 0.8em 1.5em !important;
    height: auto;
  }
</style>
